import { render, staticRenderFns } from "./picture_cube.vue?vue&type=template&id=5d1f3b9f&scoped=true"
import script from "./picture_cube.vue?vue&type=script&lang=js"
export * from "./picture_cube.vue?vue&type=script&lang=js"
import style0 from "./picture_cube.vue?vue&type=style&index=0&id=5d1f3b9f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1f3b9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d1f3b9f')) {
      api.createRecord('5d1f3b9f', component.options)
    } else {
      api.reload('5d1f3b9f', component.options)
    }
    module.hot.accept("./picture_cube.vue?vue&type=template&id=5d1f3b9f&scoped=true", function () {
      api.rerender('5d1f3b9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/picture_cube.vue"
export default component.exports